import { useFormContext } from "react-hook-form";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import { UserRole } from "../../../__generated__/graphql";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import toast from "react-hot-toast";

const Company = () => {
  const {user} = useCurrentUser()
  const {register} = useFormContext()

  const copyToClipboard = () => {
    navigator.clipboard.writeText(user.companyId);
    toast.success("Account ID copied to clipboard!");
  }

  return (
    <div className="mt-6 grid grid-cols-4 gap-6">
      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="first-name"
          className="block text-sm font-medium text-gray-700"
        >
          Name
        </label>
        <input
          type="text"
          name="name"
          id="companyName"
          readOnly={user.role === UserRole.RegularUser}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          {...register('name')}
        />
        
      </div>

      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="type"
          className="block text-sm font-medium text-gray-700"
        >
          Company Type
        </label>
        {false ? (
          <select
            id="type"
            name="type"
            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          >
            <option>Publisher</option>
            <option>Agency</option>
            <option>Advertiser</option>
          </select>
        ) : (
          <div className="mt-1 block w-full bg-white shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
            {" "}
            {user.company.type}
          </div>
        )}
      </div>

      <div className="col-span-4 sm:col-span-4">
        <label
          htmlFor="accountId"
          className="block text-sm font-medium text-gray-700"
        >
          Account ID
        </label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <div className="relative flex items-stretch flex-grow focus-within:z-10">
            <input
              type="text"
              name="accountId"
              id="accountId"
              className="focus:ring-gray-900 focus:border-gray-900 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300 bg-gray-50 text-gray-500"
              readOnly
              value={user.companyId || ""}
            />
          </div>
          <button
            type="button"
            onClick={copyToClipboard}
            className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-900 focus:border-gray-900"
          >
            <DocumentDuplicateIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            <span>Copy</span>
          </button>
        </div>
      </div>
    </div>
  )
};

export default Company;
